"use client";

import { usePathname } from "next/navigation";

/**
 * Blendet die Marketing-Chrome (Header/Footer) im geschützten Bereich
 * (Portal & Admin) sowie auf Fragebogen, Upload- und Zugänge-Link aus – dort gibt es eine eigene Navigation.
 */
export function ChromeGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  // Fragebogen, Upload- und Zugänge-Link: schlanke Seiten ohne Website-Navigation.
  const hidden = ["/portal", "/admin", "/briefing", "/unterlagen", "/zugaenge"].some((prefix) => pathname.startsWith(prefix));
  if (hidden) return null;
  return <>{children}</>;
}
